var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { defineComponent as _defineComponent } from 'vue';
import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, unref as _unref, withCtx as _withCtx, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = { class: "p-5" };
const _hoisted_2 = /*#__PURE__*/ _createElementVNode("div", { class: "columns" }, [
    /*#__PURE__*/ _createElementVNode("div", { class: "column" }, [
        /*#__PURE__*/ _createElementVNode("h2", { class: "subtitle" }, " Your Settings ")
    ])
], -1);
const _hoisted_3 = /*#__PURE__*/ _createElementVNode("hr", null, null, -1);
const _hoisted_4 = /*#__PURE__*/ _createElementVNode("h2", { class: "subtitle" }, "Account Security", -1);
const _hoisted_5 = { class: "columns" };
const _hoisted_6 = { class: "column is-narrow" };
const _hoisted_7 = /*#__PURE__*/ _createElementVNode("hr", null, null, -1);
const _hoisted_8 = /*#__PURE__*/ _createElementVNode("h2", { class: "subtitle" }, "Notifications", -1);
const _hoisted_9 = /*#__PURE__*/ _createElementVNode("p", { class: "mb-2" }, [
    /*#__PURE__*/ _createElementVNode("strong", null, "1. Install an authenticator app on your device."),
    /*#__PURE__*/ _createTextVNode(" We recommend the Google Authenticator app, available on Android and iOS. ")
], -1);
const _hoisted_10 = { class: "mb-2" };
const _hoisted_11 = /*#__PURE__*/ _createElementVNode("strong", null, "2. Scan the QR code below into your authenticator app:", -1);
const _hoisted_12 = ["src"];
const _hoisted_13 = { class: "mb-2" };
const _hoisted_14 = /*#__PURE__*/ _createElementVNode("strong", null, "3. Enter the current 6-digit code displayed within the app:", -1);
import { Validations, useValidation } from "@/composables/useValidation";
import { doApiAction } from "@/core/api";
import { clearLocalSession, sessionState } from "@/core/session";
import { getCurrentInstance, ref } from "vue";
import { apiUserSettings } from "./api";
import UserNotificationPreferencesEditor from "./UserNotificationPreferencesEditor.vue";
// UI state
export default /*#__PURE__*/ _defineComponent({
    __name: 'UserSettingsPanel',
    setup(__props) {
        var _a;
        const inProgressAction = ref(null);
        // Setting MFA
        const mfaValidation = useValidation();
        const newMfaSecret = ref(null);
        const setMfaCurrentOneTimeCode = ref("");
        const generateMfaSecret = () => {
            doApiAction(inProgressAction, "generateMfaSecret", null, "Failed to generate new MFA secret", () => __awaiter(this, void 0, void 0, function* () {
                yield apiUserSettings.generateMfaSecret()
                    .then(secret => {
                    newMfaSecret.value = secret;
                    setMfaCurrentOneTimeCode.value = "";
                });
            }));
        };
        const instance = getCurrentInstance();
        const setMfaSecret = () => {
            if (!mfaValidation.areAllFieldsValid.value)
                return;
            doApiAction(inProgressAction, "setMfaSecret", "MFA enabled - please login again", "Failed to enable MFA", () => __awaiter(this, void 0, void 0, function* () {
                yield apiUserSettings.setMfaSecret({ secret: newMfaSecret.value.secret, currentOneTimeCode: setMfaCurrentOneTimeCode.value })
                    .then(() => {
                    clearLocalSession();
                    instance.proxy.$router.push("/login");
                });
            }));
        };
        // Preferences
        const notificationPreferences = ref((_a = sessionState.session) === null || _a === void 0 ? void 0 : _a.userPreferences.notifications);
        const updatePreferences = () => {
            sessionState.session.userPreferences.notifications = notificationPreferences.value;
            doApiAction(inProgressAction, "updatePreferences", "Updated preferences", "Failed to update preferences", () => __awaiter(this, void 0, void 0, function* () {
                yield apiUserSettings.updatePreferences(sessionState.session.userPreferences);
            }));
        };
        return (_ctx, _cache) => {
            const _component_SaveButton = _resolveComponent("SaveButton");
            const _component_FormTextField = _resolveComponent("FormTextField");
            const _component_ModalDialog = _resolveComponent("ModalDialog");
            return (_openBlock(), _createElementBlock("div", null, [
                _createElementVNode("div", _hoisted_1, [
                    _hoisted_2,
                    _hoisted_3,
                    _hoisted_4,
                    _createElementVNode("div", _hoisted_5, [
                        _createElementVNode("div", _hoisted_6, [
                            _createVNode(_component_SaveButton, {
                                label: "Enable Multi-Factor Authentication",
                                icon: "fa-lock",
                                action: "generateMfaSecret",
                                inProgressAction: inProgressAction.value,
                                onClick: _cache[0] || (_cache[0] = ($event) => (generateMfaSecret())),
                                style: { "margin-top": "5px" }
                            }, null, 8, ["inProgressAction"])
                        ])
                    ]),
                    _hoisted_7,
                    _hoisted_8,
                    (notificationPreferences.value)
                        ? (_openBlock(), _createBlock(UserNotificationPreferencesEditor, {
                            key: 0,
                            modelValue: notificationPreferences.value,
                            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event) => ((notificationPreferences).value = $event))
                        }, null, 8, ["modelValue"]))
                        : _createCommentVNode("", true),
                    _createVNode(_component_SaveButton, {
                        label: "Save Preferences",
                        icon: "fa-save",
                        action: "updatePreferences",
                        inProgressAction: inProgressAction.value,
                        onClick: _cache[2] || (_cache[2] = ($event) => (updatePreferences())),
                        style: { "margin-top": "5px" }
                    }, null, 8, ["inProgressAction"])
                ]),
                _createVNode(_component_ModalDialog, {
                    active: newMfaSecret.value != null,
                    title: "Enable Multi-Factor Authentication",
                    severity: "info",
                    allowClose: true,
                    onClose: _cache[4] || (_cache[4] = ($event) => (newMfaSecret.value = null)),
                    firstButtonText: "Go Back",
                    firstButtonSeverity: "link",
                    onFirstbuttonselected: _cache[5] || (_cache[5] = ($event) => (newMfaSecret.value = null)),
                    secondButtonText: "Enable MFA",
                    secondButtonSeverity: "primary",
                    onSecondbuttonselected: _cache[6] || (_cache[6] = ($event) => (setMfaSecret()))
                }, {
                    default: _withCtx(() => {
                        var _a;
                        return [
                            _hoisted_9,
                            _createElementVNode("p", _hoisted_10, [
                                _hoisted_11,
                                _createElementVNode("img", {
                                    src: (_a = newMfaSecret.value) === null || _a === void 0 ? void 0 : _a.qrCode,
                                    class: "qrCode"
                                }, null, 8, _hoisted_12)
                            ]),
                            _createElementVNode("p", _hoisted_13, [
                                _hoisted_14,
                                _createVNode(_component_FormTextField, {
                                    label: "MFA code",
                                    modelValue: setMfaCurrentOneTimeCode.value,
                                    "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event) => ((setMfaCurrentOneTimeCode).value = $event)),
                                    validator: _unref(mfaValidation).validator(_unref(Validations).digits, _unref(Validations).length(6))
                                }, null, 8, ["modelValue", "validator"])
                            ])
                        ];
                    }),
                    _: 1
                }, 8, ["active"])
            ]));
        };
    }
});
